import { useEffect, useRef } from "react";

const GA_MEASUREMENT_ID = import.meta.env.VITE_GA4_MEASUREMENT_ID;

// Declare gtag for TypeScript
declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export const useGoogleAnalytics = () => {
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current || !GA_MEASUREMENT_ID) {
      return;
    }

    // Load the gtag.js script dynamically
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);

    script.onload = () => {
      if (window.gtag) {
        window.gtag("js", new Date());
        window.gtag("config", GA_MEASUREMENT_ID, { send_page_view: false });
      }
    };

    initialized.current = true;
  }, []);
};

// Track page views for SPA navigation
export const trackPageView = (pagePath: string) => {
  if (window.gtag && GA_MEASUREMENT_ID) {
    window.gtag("event", "page_view", {
      page_path: pagePath,
      page_title: document.title,
    });
  }
};

// Track custom events
export const trackEvent = (
  eventName: string,
  parameters?: Record<string, unknown>
) => {
  if (window.gtag && GA_MEASUREMENT_ID) {
    window.gtag("event", eventName, parameters);
  }
};
